// in-session cache of last selected report per `category:displayMode`
const lastReportByContext = new Map<string, string>();

export const rememberLastReport = (
  category: string,
  displayMode: string,
  code: string
): void => {
  lastReportByContext.set(`${category}:${displayMode}`, code);
};

export const getLastReportCode = (
  category: string,
  displayMode: string
): string | undefined => lastReportByContext.get(`${category}:${displayMode}`);
